import { Side } from '@openeducation/oe-it-shared-types';
import { styled } from '@openeducation/oe-it-themes';
import { MotiScrollView } from 'moti';
import React from 'react';
import type { StyleProp, ViewStyle } from 'react-native';

import { flex } from '../../style-utils';

type SideMenuContentProps = React.PropsWithChildren<{
  side: Side;
  width: number;
  style?: StyleProp<ViewStyle>;
}>;

export function SideMenuContent({
  side,
  width,
  style,
  children,
}: SideMenuContentProps) {
  return (
    <Container
      side={side}
      width={width}
      style={style}
      animate={{ translateX: 0 }}
      from={{ translateX: side === 'left' ? width * -1 : width }}
      exit={{ translateX: side === 'left' ? width * -1 : width }}
      transition={{ type: 'timing', duration: 500 }}
      contentContainerStyle={[flex('flex-1')]}
    >
      {children}
    </Container>
  );
}

const Container = styled(MotiScrollView)<{
  side: Side;
  width: ViewStyle['width'];
}>`
  flex: 1;
  width: ${({ width }) => width}px;
  max-width: 100%;
  background-color: ${({ theme }) => theme.color.white};
`;
